/**
 * Persona owner API client — claim lifecycle + dashboard.
 */
import { apiFetch, API_BASE } from "./api.js";

/** Get current user's application */
export async function getApplication() {
  return apiFetch("/api/persona-owner/application");
}

/** Create a new application */
export async function createApplication() {
  return apiFetch("/api/persona-owner/application", { method: "POST" });
}

/** Save draft details (no status transition) */
export async function saveDraft(details) {
  return apiFetch("/api/persona-owner/application", {
    method: "PATCH",
    body: JSON.stringify(details),
  });
}

/** Submit details (transitions to pending_verification) */
export async function submitDetails(details) {
  return apiFetch("/api/persona-owner/application", {
    method: "PATCH",
    body: JSON.stringify({ ...details, submit: true }),
  });
}

/** Upload ID document (multipart form) */
export async function uploadIdDocument(file) {
  const formData = new FormData();
  formData.append("file", file);

  const jwt = (await import("../context/AuthContext.jsx")).getAccessToken();
  const secret = import.meta.env.VITE_API_SECRET ?? "";

  const res = await fetch(`${API_BASE}/api/persona-owner/application/upload-id`, {
    method: "POST",
    headers: {
      "X-API-Secret": secret,
      ...(jwt ? { Authorization: `Bearer ${jwt}` } : {}),
    },
    body: formData, // No content-type header — browser sets multipart boundary
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: "Upload failed" }));
    throw new Error(err.error ?? "Upload failed");
  }
  return res.json();
}

/** Upload authorisation letter (multipart form) */
export async function uploadAuthLetter(file) {
  const formData = new FormData();
  formData.append("file", file);

  const jwt = (await import("../context/AuthContext.jsx")).getAccessToken();
  const secret = import.meta.env.VITE_API_SECRET ?? "";

  const res = await fetch(`${API_BASE}/api/persona-owner/application/upload-letter`, {
    method: "POST",
    headers: {
      "X-API-Secret": secret,
      ...(jwt ? { Authorization: `Bearer ${jwt}` } : {}),
    },
    body: formData,
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: "Upload failed" }));
    throw new Error(err.error ?? "Upload failed");
  }
  return res.json();
}

/** Submit application for admin review */
export async function submitForReview() {
  return apiFetch("/api/persona-owner/application/submit", { method: "POST" });
}
